import { render, staticRenderFns } from "./ListInquiriesFirstname.vue?vue&type=template&id=35067d08&"
import script from "./ListInquiriesFirstname.vue?vue&type=script&lang=js&"
export * from "./ListInquiriesFirstname.vue?vue&type=script&lang=js&"
import style0 from "./ListInquiriesFirstname.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports